import { connect } from 'react-redux'
import { getArchivedClientsList } from '../actions/actions-archived-clients'
import { getProgramsAssignedToLoginList } from '../actions/actions-programs'
import ArchivedClients from '../views/ArchivedClients/archived-clients'
const mapStateToProps = (state, ownProps) => {
  return {
    parentProps: ownProps,
    archivedclients: state.archivedclientsR.dataList,
    programsAssigned: state.programsR.programsassignedtologin
  }
}
const mapDispatchToProps = dispatch => {
  return {
    getArchivedClients: loginID => {
      dispatch(getArchivedClientsList(loginID))
    },
    getProgramsAssignedToLoginList: id => {
      dispatch(getProgramsAssignedToLoginList(id))
    }
  }
}
const ArchivedClientListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ArchivedClients)
export default ArchivedClientListContainer
